export const COUNTRYCODE_LIST = [
  { dialCode: "+32" }, // Belgium
  { dialCode: "+1" }, // United States, Canada, etc.
  { dialCode: "+44" }, // United Kingdom
  { dialCode: "+91" }, // India
  { dialCode: "+94" }, // Srilanka
  { dialCode: "+33" }, // France
  { dialCode: "+49" }, // Germany
  { dialCode: "+61" }, // Australia
  { dialCode: "+81" }, // Japan
  { dialCode: "+39" }, // Italy
  { dialCode: "+34" }, // Spain
  { dialCode: "+55" }, // Brazil
  { dialCode: "+56" }, // Chile
  { dialCode: "+57" }, // Colombia
  { dialCode: "+61" }, // Australia
  { dialCode: "+62" }, // Indonesia
  { dialCode: "+27" }, // South Africa
  { dialCode: "+82" }, // South Korea
  { dialCode: "+52" }, // Mexico
  { dialCode: "+64" }, // New Zealand
  { dialCode: "+93" }, // Afghanistan
  { dialCode: "+20" }, // Egypt
  { dialCode: "+90" }, // Turkey
  { dialCode: "+86" }, // China
  { dialCode: "+7" }, // Russia, Kazakhstan
  { dialCode: "+234" }, // Nigeria
  { dialCode: "+971" }, // United Arab Emirates (UAE)
  { dialCode: "+977" }, // Nepal
  { dialCode: "+971" }, // United Arab Emirates
  { dialCode: "+998" }, // Uzbekistan
  { dialCode: "+966" }, // Saudi Arabia
  { dialCode: "+27" }, // South Africa
  { dialCode: "+47" }, // Norway
  { dialCode: "+41" }, // Switzerland
  { dialCode: "+63" }, // Philippines
  { dialCode: "+254" }, // Kenya
  { dialCode: "+92" }, // Pakistan
  { dialCode: "+53" }, // Cuba
  { dialCode: "+421" }, // Slovakia
  { dialCode: "+420" }, // Czech Republic
  { dialCode: "+351" }, // Portugal
  { dialCode: "+355" }, // Albania
  { dialCode: "+971" }, // UAE
];
